import React from 'react';
import { PhaseStepBlock } from './PhaseStepBlock';
import {
    getFirstIncompletedPhaseStepIndex,
    getPhaseStepLimitKeyByOrder,
    PHASE_STEP_INCOMPLETED,
    getPhaseStepStatus,
    getPhaseStepTranslationKey,
} from '../shared/utils/phase';
import { getMealCount } from '../shared/utils/meals';

export const PhaseStepNavigation = (props) => {
    const {
        phaseSteps,
        setSpecificPhaseStep,
        phase,
        loadActivePhaseProductsFromStorage,
        productAvailabilityMap,
        translations,
        activePhaseStep,
        phaseStepProductExceededAvailabilityMap,
    } = props;

    const pickedPhaseProducts = loadActivePhaseProductsFromStorage();
    const hasPhaseSteps = phaseSteps && phaseSteps.length > 0;

    const firstIncompletedPhaseStepIndex = getFirstIncompletedPhaseStepIndex(
        phase,
        pickedPhaseProducts,
        productAvailabilityMap
    );

    return (
        <div>
            <h3 className="h3 phase-step-navigation-title">{translations['eshop.configurator.action.pick_meals']}:</h3>
            <div className="phase-step-navigation-wrapper">
                {hasPhaseSteps ? (
                    phaseSteps.map((phaseStep, index) => (
                        <PhaseStepBlock
                            key={index}
                            phaseStepName={translations[getPhaseStepTranslationKey(phaseStep)]}
                            phase={phase}
                            onPhaseStepBlockClick={() => setSpecificPhaseStep(phaseStep)}
                            hasPhaseStepMealsCompleted={true}
                            pickedProductsCount={
                                pickedPhaseProducts && pickedPhaseProducts[phaseStep]
                                    ? getMealCount(pickedPhaseProducts[phaseStep])
                                    : 0
                            }
                            mealsLimit={phase ? phase[getPhaseStepLimitKeyByOrder(phaseStep)] : 0}
                            isDisabled={index > firstIncompletedPhaseStepIndex}
                            phaseStepStatus={
                                pickedPhaseProducts && pickedPhaseProducts[phaseStep]
                                    ? getPhaseStepStatus(
                                          pickedPhaseProducts[phaseStep],
                                          phase ? phase[getPhaseStepLimitKeyByOrder(phaseStep)] : 0,
                                          productAvailabilityMap
                                      )
                                    : PHASE_STEP_INCOMPLETED
                            }
                            translations={translations}
                            isFirst={index === 0}
                            isLast={index === phaseSteps.length - 1}
                            isActive={phaseStep === activePhaseStep}
                            productExceedAvailability={
                                (phaseStepProductExceededAvailabilityMap[phase.id] &&
                                    phaseStepProductExceededAvailabilityMap[phase.id][phaseStep]) ||
                                false
                            }
                        />
                    ))
                ) : (
                    <div>{translations['eshop.configurator.action.no_dish_types']}</div>
                )}
            </div>
            <div className="phase-step-navigaiton-content-divider"></div>
        </div>
    );
};
